import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, Observable, tap, throwError } from 'rxjs';
import { STATIC_DATA } from '../shared/constants/static-data.constants';
import { GlobalErrorHandlerService } from '../shared/services/global-error-handler.service';
import { HttpRequestService } from '../shared/services/http-request.service';
import { NotificationService } from './../shared/services/notification.service';
import { SectionsService } from './sections.service';
import { ENDPOINTS } from '../shared/constants/url.constants';
import { formatUrl } from '../shared/utils/format-url-util';

@Injectable({
  providedIn: 'root',
})
export class LeadDetailsService {
  private selectedLeadId: number | null = null;

  private previousData$ = new BehaviorSubject<any>(null);
  private leadStatus$ = new BehaviorSubject<any>('');

  constructor(
    private http: HttpRequestService,
    private notificationService: NotificationService,
    private errorHandler: GlobalErrorHandlerService,
    private sectionService: SectionsService,
  ) { }

  setLeadStatus(newStatus: string): void {
    this.leadStatus$.next(newStatus)
  }

  getLeadStatus(): Observable<any> {
    return this.leadStatus$.asObservable();
  }

  getUpdatedLeadData(): Observable<any> {
    return this.previousData$.asObservable();
  }
  

  getEntry(entry : string) : string{
    let userEntry = '';
    if(entry == STATIC_DATA.REFERRAL){
      userEntry = 'refferalparticipant';
    } else if(entry === STATIC_DATA.PARTICIPANT_ENROLLMENT){
      userEntry = 'prtcpntenrlmnt';
    } else if(entry === STATIC_DATA.PROVIDER_ENROLLMENT){
      userEntry = 'providerenrlmnt';
    }else{
       userEntry = entry;
    }
    return userEntry;
  }

  fetchProviderDetailsById(providerPPLId: string) {
    
  }

  unmaskIdentifier(program_code: string, payload: any): Observable<any> {
    const url = formatUrl(ENDPOINTS.UNMASK_Identifier, { program_code });
    return this.http.post(url, payload).pipe(
      tap(() => {
      }),
      catchError((err) => {
        return throwError(() => this.errorHandler.handleError(err));
      })
    );
  }

}
